import Image from 'next/image';

import { BodyRegular } from '../common/body';
import { H3, H4 } from '../common/headline';

import tom from '@public/img/how-it-works/coach-tom.png';
import deborah from '@public/img/how-it-works/coach-deborah.png';
import grace from '@public/img/how-it-works/coach-grace.png';

export const MounjaroHabitBuilderSupport = (): JSX.Element => (
  <div className="flex w-full items-center justify-center bg-blue px-4 py-14 lg:px-[60px] lg:py-24">
    <div className="flex min-w-full flex-col items-center justify-between">
      <div className="mb-12 flex flex-col text-center text-mono-white xl:max-w-[448px]">
        <H3>
          We{"'"}re here to <span className="text-salmon">support you </span>
          whenever you need it
        </H3>
      </div>
      <div className="flex w-full max-w-[1320px] flex-col lg:flex-row lg:justify-between lg:space-x-8">
        <div className="mb-12 flex flex-col items-start text-mono-white">
          <div className="mb-4 max-h-[200px] min-h-[200px]">
            <Image src={tom} alt="Coach Tom" width={329} height={184} />
          </div>
          <div className="mb-2 md:mt-4">
            <H4>Managing side effects</H4>
          </div>
          <div className="max-w-[343px]">
            <BodyRegular>
              While most people only experience mild side effects that ease once
              you{"'"}ve adapted to the medication, your health coach and
              pharmacist will be on hand to help you manage them.
            </BodyRegular>
          </div>
        </div>
        <div className="mb-12 flex flex-col items-start text-mono-white">
          <div className="mb-4 max-h-[200px] min-h-[200px]">
            <Image src={grace} alt="Coach Grace" width={329} height={184} />
          </div>
          <div className="mb-2 md:mt-4">
            <H4>Building new healthy habits</H4>
          </div>
          <div className="max-w-[343px]">
            <BodyRegular>
              When you reach your goal weight and decide to come off the
              medication, new healthy habits will help you to maintain your
              weight loss for the long term.
            </BodyRegular>
          </div>
        </div>
        <div className="flex flex-col items-start text-mono-white">
          <div className="mb-4 max-h-[200px] min-h-[200px]">
            <Image src={deborah} alt="Coach Deborah" width={329} height={184} />
          </div>
          <div className="mb-2 md:mt-4">
            <H4>Overcoming any challenges</H4>
          </div>
          <div className="max-w-[343px]">
            <BodyRegular>
              Whether it{"'"}s support with motivation, accountability, or
              tailoring recipes to your preferences, we{"'"}ll support you in
              whatever way you need. For some people that might be intensive
              coaching, and for others it{"'"}s a reassuring guide to know you
              {"'"}re on the right path.
            </BodyRegular>
          </div>
        </div>
      </div>
    </div>
  </div>
);
